export default class Config {
    constructor() {
        this.initialized = false;
        this.domElement = null;
        this.isDevEnvironment = false;
        this.contactTypes = {
            none: 1,
            product: 2,
            marketSegment: 3,
            investorRelations: 4,
            careers: 5,
            media: 6,
            other: 7,
            businessUnit: 8,
            locations: 1000,
            procurement: 1003
        };
        this.steps = {
            contactTypeSelector: 1,
            productContactSelector: 2,
            contactList: 3,
            contactForm: 6,
            submitForm: 10000,
            locations: 1000,
            sampleOrder: 1001,
            productSearch: 1002,
            procurement: 1003
        };
        this.wsRootUrl = "/api";
        this.commonTextsRoot = "{4CE2DB49-C138-4618-B14A-B2BBF7664640}";
        this.locationsPath = "/company/locations";
        this.procurementPath = "/Company/Global-Function-Procurement/Contact-Form";
        this.productSearchPath = "/Corporate/Search";
        this.icsTagId = "{D0E29A53-982E-4447-B043-1796346C0B62}";
        this.catalystsTagId = "{87CA800E-BD3C-42D4-ABAA-9DAF046F48E0}";
        this.additivesTagId = "{5386A6B9-F9A8-4AA9-83C6-FECEDD43018D}";
        this.defaultContactId = "{0B0C66B9-818A-4020-9486-D116C6E406EE}";
        this.defaultContactImage = "https://www.clariant.com/-/media/Images/Resources/People/global/avatar3.png?la=en&mw=400&mh=400";
        this.investorRelationsTagId = "{2717D820-D172-43E0-B9E4-3FF58B950848}";
        this.careersTagId = "{931150FD-499D-40D2-A943-C86F1208B0EE}";
        this.mediaTagId = "{744AA225-0FD2-4FDC-AE53-1A34E13AC296}";
        this.defaultCountry = "F8E6CE2DA87F48EDB0D7BF912A78F080";
        this.defaultRegion = "26D626B56C764422A0573DF71844193C";
        this.jumpToSampleOrder = 1001;
        this.jumpToProductSearch = 1002;
        //contact box settings
        this.layout = "vertical";
        this.buId = "";
        this.blId = "";
        this.contactId = "";
        this.contactTagId = "";
        this.theme = "blue-06";
        this.legacy = "";
    }
    init(el) {
        if (this.initialized) return;
        if (el == null) return;

        this.domElement = el.parentNode;
        this.wsRootUrl = this.getElementValue("wsrooturl", this.wsRootUrl);
        this.commonTextsRoot = this.getElementValue("commontexts", this.commonTextsRoot);
        this.locationsPath = this.getElementValue("locationspath", this.locationsPath);
        this.procurementPath = this.getElementValue("procurementpath", this.procurementPath);
        this.productSearchPath = this.getElementValue("productsearchpath", this.productSearchPath);
        this.icsTagId = this.getElementValue("icstagid", this.icsTagId);
        this.catalystsTagId = this.getElementValue("catalyststagid", this.catalystsTagId);
        this.additivesTagId = this.getElementValue("additivestagid", this.additivesTagId);
        this.defaultContactId = this.getElementValue("defaultcontact", this.defaultContactId);
        this.defaultContactImage = this.getElementValue("defaultimage", this.defaultContactImage);
        this.investorRelationsTagId = this.getElementValue("investorstagid", this.investorRelationsTagId);
        this.careersTagId = this.getElementValue("careerstagid", this.careersTagId);
        this.mediaTagId = this.getElementValue("mediaTagId", this.mediaTagId);
        this.defaultCountry = this.getElementValue("defaultcountry", this.defaultCountry);
        this.defaultRegion = this.getElementValue("defaultregion", this.defaultRegion);
        this.layout = this.getElementValue("contactboxlayout", this.layout);
        this.buId = this.getElementValue("buid", this.buId);
        this.blId = this.getElementValue("blid", this.blId);
        this.contactId = this.getElementValue("contactid", this.contactId);
        this.contactTagId = this.getElementValue("contacttag", this.contactTagId);
        this.theme = this.getElementValue("theme", this.theme);
        this.legacy = this.getElementValue("legacy", this.legacy);
        this.initialized = true;
    }
    getElementValue(name, defaultValue) {
        if (!this.domElement || !name) return defaultValue;
        var el = this.domElement.querySelector(`input[name="${name}"]`);
        if (el) return el.value || defaultValue;
        else return defaultValue;
    }
};